import asyncStorageProvider from '../persisted/usePersistedObject/asyncStorageProvider';
// On web, we use @react-native-async-storage/async-storage instead of react-native-sensitive-info
// because it is not currently possible to create a secured storage in modern browsers.
// According to [this comment](https://github.com/expo/expo/issues/7744#issuecomment-611093485) on
// the expo-secure-store github:
// "Unfortunately secure store API isn't available on web, we won't be polyfilling this package
// because there is no secure way to store values in the browser. If this changes we'll be happy to
// work on this."
export default asyncStorageProvider;
//# sourceMappingURL=potentiallySecuredStorageProvider.web.js.map